export class ImportRefineryResponse {
    refineryGuid: string = "";
    refineryName: string = "";
    revision: number = 0;
    // Non-blocking notices from the server — e.g. an ingest data file referenced
    // by an imported config that wasn't found at this destination. The import
    // still succeeded; these are surfaced to the Analyst, never dropped silently.
    warnings: string[] = [];

    constructor(refineryGuid: string, refineryName: string, revision: number, warnings: string[]) {
        this.refineryGuid = refineryGuid;
        this.refineryName = refineryName;
        this.revision = revision;
        this.warnings = warnings ?? [];
    }
}
